import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Input, Space, message, Tag } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { productApi } from '@/services/api';

const ProductList = () => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadProducts();
  }, [pagination.current, pagination.pageSize]);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const response = await productApi.list({
        page: pagination.current,
        limit: pagination.pageSize,
        search
      });

      if (response.data.success) {
        setProducts(response.data.data);
        setPagination({
          ...pagination,
          total: response.data.pagination.total
        });
      }
    } catch (error) {
      message.error('載入商品列表失敗');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku'
    },
    {
      title: '商品名稱',
      dataIndex: 'product_name',
      key: 'product_name'
    },
    {
      title: '品牌',
      dataIndex: 'brand',
      key: 'brand'
    },
    {
      title: '分類',
      dataIndex: 'category',
      key: 'category'
    },
    {
      title: '建議售價',
      dataIndex: 'suggested_price',
      key: 'suggested_price',
      render: (price) => `NT$ ${parseFloat(price).toLocaleString()}`
    },
    {
      title: '庫存',
      dataIndex: 'stock_qty',
      key: 'stock_qty',
      render: (qty, record) => {
        const isBelowSafe = qty < record.safe_stock_qty;
        return (
          <Tag color={isBelowSafe ? 'red' : 'green'}>
            {qty}
          </Tag>
        );
      }
    },
    {
      title: '狀態',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (isActive) => (
        <Tag color={isActive ? 'success' : 'default'}>
          {isActive ? '啟用' : '停用'}
        </Tag>
      )
    }
  ];

  return (
    <div>
      <Card>
        <Space style={{ marginBottom: 16 }} wrap>
          <Input
            placeholder="搜尋商品"
            prefix={<SearchOutlined />}
            style={{ width: 250 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={loadProducts}
          />
          <Button onClick={loadProducts}>查詢</Button>
          <Button type="primary" icon={<PlusOutlined />}>
            新增商品
          </Button>
        </Space>

        <Table
          columns={columns}
          dataSource={products}
          loading={loading}
          rowKey="id"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 筆`,
            onChange: (page, pageSize) => {
              setPagination({ ...pagination, current: page, pageSize });
            }
          }}
        />
      </Card>
    </div>
  );
};

export default ProductList;
